import React from "react";
import { Alert } from "antd";
// import { Affix } from "antd";
import "styles/MessageBanner.scss";

export default function MessageBanner({ message }) {
  return (
    // <Affix offsetTop={0}>
    <div id="message-banner">
      <Alert
        type="info"
        message={<div className="message-banner">{message}</div>}
        banner
      />
    </div>
    // </Affix>
  );
}
